import React from "react";
import styles from './commentmobile.module.css';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material";
import { ArrowLeft, Camera, Edit, MoreVertical, Plus, Search, Trash2, X } from "react-feather";
import { Dropdown } from "react-bootstrap";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from 'react-smart-toaster';
import { AddLogCallAPI } from "../../../../components/AddLogs";
import axios from 'axios';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import dayjs from "dayjs";

const schemaNote = yup.object().shape({
    note: yup.string().required('This field is Required').max(200, 'Notes cannot be more than 200 characters'),
});

const Initials = ({ fullName }) => {
    const parts = fullName.trim().split(" ");
    if (parts.length >= 2) {
        return (
            parts[0].charAt(0).toUpperCase() +
            parts[parts.length - 1].charAt(0).toUpperCase()
        );
    }
    return parts[0].substring(0, 2).toUpperCase();
}

const CommentMobile = ({ isPanelOpen, onToggle, complaintData, setComplaintData, setLoading, setSnackbarMsg, setSnackbarOpen }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [searchKey, setSearchKey] = useState("");
    const [noteModalOpen, setNoteModalOpen] = useState(false);
    const [deleteNoteModalOpen, setDeleteNoteModalOpen] = useState(false);
    const [noteID, setNoteID] = useState(0);
    const [notes, setNotes] = useState([]);

    const { control, handleSubmit, errors, setValue } = useForm({
        resolver: yupResolver(schemaNote),
        defaultValues: {
            note: ""
        }
    });

    useEffect(() => {
        if (complaintData) {
            let filteredData = complaintData?.notes;
            if (searchKey !== '') {
                filteredData = filteredData.filter((item) => item?.note.toLowerCase().includes(searchKey.toLowerCase()));
            }

            setNotes(filteredData);
        }
    }, [complaintData, searchKey]);

    const onSubmit = async (data) => {
        setLoading(true);
        setNoteModalOpen(false);
        const postData = data;
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        if (noteID) {
            axios.put(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes/' + noteID, postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setLoading(false);
                setSnackbarMsg(response.data.message);
                setSnackbarOpen(true);
                let note = response.data.data;

                setComplaintData(prev => {
                    return {
                        ...prev, notes: prev.notes?.map(i => {
                            if (i?.id === noteID)
                                return { ...i, note: note?.note };
                            return i;
                        })
                    }
                });

                let logData = {
                    'title': 'Complaint new note is updated',
                    'description': [
                        'Name: ' + complaintData?.title,
                        'Complaint number: ' + complaintData?.complaint_no,
                        'Property: ' + complaintData?.property_name,
                        'Apartment: ' + complaintData?.apt_name,
                        'Tenant: ' + complaintData?.tenant_name,
                        'Comment: ' + note?.note,
                    ]
                }

                AddLogCallAPI(logData, this.token);
                setNoteID(0);
            }).catch(error => {
                setLoading(false);
                setNoteID(0);
                if (typeof error.response !== 'undefined')
                    toast.error(error.response.data.message);
            });
        } else {
            axios.post(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes', postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then(response => {
                setLoading(false);
                setSnackbarMsg(response.data.message);
                setSnackbarOpen(true);
                let note = response.data.data;

                setComplaintData(prev => {
                    return { ...prev, notes: [note]?.concat(prev.notes) }
                });

                let logData = {
                    'title': 'Complaint new note is created',
                    'description': [
                        'Name: ' + complaintData?.title,
                        'Complaint number: ' + complaintData?.complaint_no,
                        'Property: ' + complaintData?.property_name,
                        'Apartment: ' + complaintData?.apt_name,
                        'Tenant: ' + complaintData?.tenant_name,
                        'Comment: ' + note?.note,
                    ]
                }

                AddLogCallAPI(logData, this.token);
            }).catch(error => {
                setLoading(false);
                if (typeof error.response !== 'undefined')
                    toast.error(error.response.data.message);
            });
        }
    }

    const delConfirm = async () => {
        setLoading(true);
        setDeleteNoteModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        axios.delete(process.env.REACT_APP_CASE_API_URL + 'v1/complaints/' + complaintData?.id + '/notes/' + noteID, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setLoading(false);
            setSnackbarMsg(response.data.message);
            setSnackbarOpen(true);

            setNoteID(0);

            setComplaintData(prev => {
                return { ...prev, notes: prev.notes?.filter(ii => ii?.id !== noteID) }
            });
        }).catch(error => {
            setLoading(false);
            setNoteID(0);
        });
    }

    return (<>
        <div className={`${styles.AccordionList}`}>
            <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("four")}>
                <p className={`${styles.Title}`}>Comments</p>
                <img src="/static/img/downTriangle.svg" />
            </div>
            <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
                <div className={`${styles.NotesSearchArea}`}>
                    <div className={`${styles.NotesSearchMain}`}>
                        <Search />
                        <input type="text" placeholder="Search" className={`${styles.searchInput}`} onChange={(e) => setSearchKey(e.target.value)} />
                    </div>
                    {(isAuthenticated && user['https://propertydek.com/permissions'].indexOf('complaint-note:create') > -1) && <button className={`${styles.AddNoteBu}`} onClick={(e) => { setNoteModalOpen(true); setNoteID(0); }}><Plus /></button>}
                </div>

                {notes.length === 0 && <div className={`${styles.NoDataMain}`}>
                    <div className={`${styles.NoDataIMG}`}>
                        <img src="/static/img/nodata.svg" alt="No Data" />
                    </div>
                    <p className={`${styles.NoDataText}`}>No Data Found</p>
                </div>}


                {notes.length > 0 && <div className={`${styles.TabBodySec}`}>
                    {notes?.map(i => {
                        return <div className={`${styles.WorkOrderCard}`}>
                            <div className={`${styles.CardAvatar}`}><p><Initials fullName={i?.user_name} /></p></div>
                            <div className={`${styles.CardDetails}`}>
                                <p className={`${styles.Title}`}>{i?.user_name}</p>
                                <p className={`${styles.SubTitle}`}>{i.role}</p>
                                <p className={`${styles.SubTitle}`}>{dayjs(i?.created_at).fromNow()}</p>
                                <p className={`${styles.Description}`}>{i?.note}</p>
                                <div className={`${styles.WorkOrderActionBU}`}>
                                    <Dropdown>
                                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                                            <MoreVertical />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => {
                                                setNoteModalOpen(true);
                                                setNoteID(i?.id);
                                                setTimeout(() => {
                                                    setValue('note', i?.note);
                                                }, 1000);
                                            }}>
                                                <Edit /> Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteNoteModalOpen(true); setNoteID(i?.id); }}>
                                                <Trash2 /> Delete
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </div>
                    })}
                </div>}
            </div>
        </div>

        <Dialog
            open={noteModalOpen}
            fullWidth
            maxWidth="xs"
            onClose={(e) => setNoteModalOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp MobileForm"
        >
            <DialogTitle id="alert-dialog-title">
                <button className={`${styles.BackAddBU}`} onClick={(e) => setNoteModalOpen(false)}><ArrowLeft /></button>
                {noteID ? "Update Note" : "Add Note"}
                <button onClick={(e) => setNoteModalOpen(false)}><X /></button>
            </DialogTitle>
            <DialogContent className={`${styles.RequestBodyPop}`}>
                <div className={`${styles.ModalFormGroup}`}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={`${styles.PopFormGroup}`}>
                            <div className={`${styles.FormGroupFull} FormGroup`}>
                                <Controller
                                    name={`note`}
                                    control={control}
                                    render={(field) => (<TextField
                                        {...field}
                                        label="Comments*"
                                        variant="outlined"
                                        multiline
                                        rows={6}
                                    />)}
                                />
                                {errors.note && <p className={`${styles.ErrorM}`}>{errors.note.message}</p>}
                            </div>
                        </div>
                        <div className={`${styles.ButtonAction}`}>
                            <Button onClick={(e) => setNoteModalOpen(false)} className="CancelPopupBU" type="button">Cancel</Button>
                            <Button className="SubmitPopupBU" type="submit">{noteID ? "Update" : "Add"}</Button>
                        </div>
                    </form>
                </div>
            </DialogContent>
        </Dialog>

        <Dialog
            open={deleteNoteModalOpen}
            fullWidth
            maxWidth="sm"
            onClose={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="NewPopUp"
        >
            <DialogTitle id="alert-dialog-title">Delete Note<button onClick={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }}><X /></button></DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <div className="ModalFormGroup">
                        <label className="PopupBodyText">Are you sure you want to delete this item?</label>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className="DeletePopupBU" onClick={(e) => delConfirm()}>Delete</Button>
                <Button onClick={(e) => { setDeleteNoteModalOpen(false); setNoteID(0); }} className="CancelPopupBU">Cancel</Button>
            </DialogActions>
        </Dialog>
    </>)
}

export default CommentMobile;
